(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const prepareLuaraFooter = root => {
    if (window.matchMedia('(max-width: 749px)').matches) {
      root.querySelectorAll('.luara-footer__details').forEach(item => item.removeAttribute('open'));
    }
    root.querySelectorAll('[data-social-name]').forEach(slot => {
      if (slot.childElementCount > 0) return;
      const name = slot.dataset.socialName;
      const source = document.querySelector(`.billion-header-drawer__socials [aria-label="${name}"]`);
      if (!source) return;
      slot.appendChild(source.cloneNode(true));
      const url = slot.dataset.socialUrl;
      if (url && source.parentElement.tagName !== 'A') {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener';
        link.setAttribute('aria-label', name);
        source.parentNode.insertBefore(link, source);
        link.appendChild(source);
      }
    });
  };
  document.querySelectorAll('.luara-footer').forEach(prepareLuaraFooter);
  document.addEventListener('shopify:section:load', event => {
    const footer = event.target.querySelector('.luara-footer');
    if (footer) prepareLuaraFooter(footer);
  });

  } catch(e) { console.error(e); }
})();
})();
